<!-- Button -->
<button
  type="button"
  [matMenuTriggerFor]="userActions"
  class="relative flex h-10 w-10 items-center justify-center rounded-full p-1.5 border-0 bg-transparent cursor-pointer outline-none hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
  matRipple
  [matRippleCentered]="true"
>
  <div class="relative h-full w-full">
    <img
      *ngIf="showAvatar && user?.profile_picture && profilePicture"
      class="h-full w-full rounded-full object-cover"
      [src]="profilePicture | secure | async"
    />
    <mat-icon
      class="absolute inset-0 h-full w-full"
      *ngIf="!showAvatar || !user?.profile_picture"
      [svgIcon]="'heroicons_outline:user-circle'"
    ></mat-icon>
  </div>
  <span
    class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
    [ngClass]="{
      'mr-px mb-px': !showAvatar || !user?.profile_picture,
      'bg-green-500': user?.status === 'online',
      'bg-amber-500': user?.status === 'away',
      'bg-red-500': user?.status === 'busy',
      'bg-gray-400': user?.status === 'not-visible',
    }"
  ></span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <mat-divider class="my-2"></mat-divider>

  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
    <span>Sign out</span>
  </button>

  <button mat-menu-item (click)="updatePassword()">
    <mat-icon [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
    <span>Update Password</span>
  </button>
</mat-menu>
